<template>
  <z-card width="100%" class="pa-0">
    <template #content>
      <v-list class="pa-0" dense nav>
        <template v-if="items.length > 0">
          <z-exclusion-list
            :items="allItemsInput"
            @include="onSelectAll('include')"
            @exclude="onSelectAll('exclude')"
          ></z-exclusion-list>

          <v-divider></v-divider>
        </template>

        <z-scrollbar
          :style="{
            maxHeight: maxHeight,
            overflow: 'hidden',
          }"
        >
          <z-exclusion-list
            :loading="loading"
            :items="items.slice(0, maxDisplayedItems)"
            @include="onInclude"
            @exclude="onExclude"
          >
          </z-exclusion-list>
        </z-scrollbar>

        <v-list-item v-if="!loading && !items.length">
          <v-list-item-content>
            <v-list-item-title> {{ $t('no_results') }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </z-card>
</template>

<script>
export default {
  props: {
    inputValue: {
      type: String,
      default: '',
    },

    items: {
      type: Array,
      default: () => [],
    },

    maxHeight: {
      type: String,
      default: '300px',
    },

    loading: {
      type: Boolean,
      default: false,
    },

    maxDisplayedItems: {
      type: Number,
      default: 50,
    },
  },

  computed: {
    allItemsInput() {
      return [
        {
          text: `${this.$t('select_all_containing', {
            inputValue: this.inputValue,
          })}`,
          value: this.inputValue,
          type: '',
        },
      ]
    },
  },
  methods: {
    /**
     * Controla a seleção de todos os itens.
     * @param {'include' | 'exclude'} type
     */
    onSelectAll(type) {
      const items = this.items.map((item) => {
        return {
          ...item,
          type,
        }
      })

      this.$emit('select-all', items)
    },

    onInclude(item) {
      this.$emit('include', item, 'items')
    },

    onExclude(item) {
      this.$emit('exclude', item, 'items')
    },
  },

  i18n: {
    messages: {
      en: {
        no_results: 'No results found',
        select_all_containing: 'Select all containing "{inputValue}"',
      },

      pt: {
        no_results: 'Nenhum resultado encontrado',
        select_all_containing: 'Selecionar todos contendo "{inputValue}"',
      },

      es: {
        no_results: 'No se encontraron resultados',
        select_all_containing:
          'Seleccion todos los que contienen "{inputValue}"',
      },
      fr: {
        no_results: 'Aucun résultat trouvé',
        select_all_containing: 'Sélectionner tout contenant "{inputValue}"',
      },
      tr: {
        no_results: 'Sonuç bulunamadı',
        select_all_containing: '"{inputValue}" içeren tümünü seç',
      },
    },
  },
}
</script>
